module.exports = __webpack_public_path__ + "img/rut956.bb106bf.gif";